<div
  class="photo"
  cdkDragHandle
  [style.width.px]="width"
  [style.height.px]="height"
  [style.backgroundImage]="'url(' + image + ')'"
>
  <div class="flex photo-content jcsb">
    <rx-row class="flex-nosize" [ngClass]="hasCheckbox ? 'jcsb' : 'jcfe'">
      <mat-checkbox
        [checked]="checked"
        [id]="id + '-checkbox'"
        (change)="checkedChanged($event)"
        *ngIf="hasCheckbox"
      ></mat-checkbox>

      <div class="action-controls flex flex-row flex-nosize" *ngIf="showMenuHandle">
        <rx-icon
          *ngIf="showMenuHandle"
          name="icon-shadow-menu"
          class="rel z1 cp"
          [class.disabled]="disableMenu"
          (click)="onMenuClicked($event)"
          [matMenuTriggerFor]="actionMenu"
          [matMenuTriggerData]="actionMenuContext"
        ></rx-icon>
      </div>
    </rx-row>

    <div class="description">
      {{ description }}
    </div>
  </div>
</div>
